import { ILogger } from "./types";

const Logger: ILogger = {
    error: (obj: any) => console.error(obj),
};

export default Logger;
